import { Skeleton } from "@mui/material";
import { styled } from "@mui/system";
import { Link as RouterLink } from "react-router-dom";
import RightArrowIcon from "src/icons/portfolio/RightArrowIcon";
import CopyOnClick from "src/utils/hooks/useCopy";
import { IReferralData } from "../defaults";
import { truncateString } from "../helpers";
import { trackEvent } from "src/Amplitude";

export const ReferLinkWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "12px",
  zIndex: 1,
}));

export const ReferLinkHeader = styled(RouterLink)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: "6px",
  fontSize: "16px",
  fontWeight: 600,
  textDecoration: "none",
  color: "inherit",
  cursor: "pointer",
  alignSelf: "stretch",
});

export const ReferLinkSubHeader = styled("div")({
  width: "267px",
});

export const ReferLinkSubHeaderIcon = styled("div")({
  cursor: "pointer",
});

export const ReferLinkText = styled("div")(({ theme }) => ({
  color: theme.palette.mode === "light" ? "#790202" : "#AE6767",
  fontSize: "12px",
}));

export const ReferShareLink = styled("div")(({ theme }) => ({
  display: "flex",
  fontSize: "12px",
  alignSelf: "stretch",
  padding: "2px 2px 2px 8px",
  justifyContent: "space-between",
  flex: "1 0 0",
  alignItems: "center",
  gap: "4px",
  borderRadius: "16px",
  border: `1px dashed  ${theme.palette.primary.main}`,
}));

export const ReferShareButton = styled("div")(({ theme }) => ({
  display: "flex",
  padding: " 4px 12px",
  alignItems: "center",
  gap: "4px",
  borderRadius: "16px",
  background: theme.palette.primary.main,
  color: "#FFF",
  cursor: "pointer",
  userSelect: "none",
  fontSize: "14px",

  /* Shadow (MD)/Standard */
  boxShadow: `0px 8px 16px 0px ${
    theme.palette.mode === "light" ? "rgba(216, 216, 218, 0.90)" : "rgba(0, 0, 0, 0.55)"
  }`,

  "&:hover": {
    background: theme.palette.mode === "light" ? "#4E7086" : "#273843",
  },

  "&:focus": {
    backgroundColor: theme.palette.mode === "light" ? "#E8F6FF" : "#747B7F",
    color: "#002035",
  },
}));

interface DesktopReferralProps {
  isLoading: boolean;
  data: IReferralData;
}

const DesktopReferral = (props: DesktopReferralProps) => {
  const { isLoading, data } = props;

  const handleAmplitudeTracking = () => {
    trackEvent("Clicked share code button", { component: "DesktopReferral" }, "RaF");
  };

  if (isLoading) return <Skeleton variant="rounded" width={"100%"} height={"121px"} />;

  return (
    <ReferLinkWrapper>
      <ReferLinkHeader to="/refer-a-friend">
        <ReferLinkSubHeader>Share your code to start earning today!</ReferLinkSubHeader>
        <ReferLinkSubHeaderIcon>
          <RightArrowIcon />
        </ReferLinkSubHeaderIcon>
      </ReferLinkHeader>
      <ReferLinkText>Help share your love of cryptocurrency while being rewarded.</ReferLinkText>
      <ReferShareLink translate="no">
        {truncateString(`app.calebandbrown.com/signup?referrer=${data.code}`, 35)}
        <CopyOnClick text={`app.calebandbrown.com/signup?referrer=${data.code}`}>
          <ReferShareButton onClick={handleAmplitudeTracking}>Copy</ReferShareButton>
        </CopyOnClick>
      </ReferShareLink>
    </ReferLinkWrapper>
  );
};

export default DesktopReferral;
